module.exports = __webpack_public_path__ + "img/y-184.d4d156e4.png";